import React from 'react'

const CollectionDetails = () => {
  return (
    <div>CollectionDetails</div>
  )
}

export default CollectionDetails